/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AgentHistoryRefetchQueryVariables = {
    agentId: string;
    first?: number | null | undefined;
    after?: string | null | undefined;
    last?: number | null | undefined;
    before?: string | null | undefined;
    around?: string | null | undefined;
    when?: string | null | undefined;
    includeCancelled?: boolean | null | undefined;
};
export type AgentHistoryRefetchQueryResponse = {
    readonly node: {
        readonly " $fragmentRefs": FragmentRefs<"AgentHistory_agent">;
    } | null;
};
export type AgentHistoryRefetchQuery = {
    readonly response: AgentHistoryRefetchQueryResponse;
    readonly variables: AgentHistoryRefetchQueryVariables;
};



/*
query AgentHistoryRefetchQuery(
  $agentId: ID!
  $first: Int
  $after: DateTime
  $last: Int
  $before: DateTime
  $around: ID
  $when: DateTime
  $includeCancelled: Boolean
) {
  node(id: $agentId) {
    __typename
    ... on Agent {
      ...AgentHistory_agent_26PW9Q
    }
    id
  }
}

fragment AgentHistoryAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  currency
  isDeposit
  amount
  customerName
  customerMobile
  maybeTerminatedCustomerMobile
  agentId
  agentName
  agentUfid
  agentUserName
  subagentId
  subagentName
  subagentUfid
  type
  isBusinessWalletAtx
  merchantUfid
  merchantId
  walletAgentUfid
  walletAgentId
  isCancelled
  composingEntries {
    __typename
    amount
    summary
    isPending
    isCancelled
    whenEntered
    ... on AgentTransactionEntry {
      agentTransactionId
      isDeposit
    }
    id
  }
  relatedTicket {
    status
    slackMessageUrl
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...AgentHistoryEntry_entry
}

fragment AgentHistoryEntryDelegate_entry on HistoryEntry {
  __isHistoryEntry: __typename
  __typename
  ...AgentHistoryEntry_entry
  ...AgentHistoryAtxEntry_tx
}

fragment AgentHistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment AgentHistorySummary_summary on AgentDailySummary {
  date
  whenDayEnded
  dailyAward
  numSignups
  absoluteTransactionVolume
  effectiveTransactionVolume
  totalCommission
}

fragment AgentHistory_agent_26PW9Q on Agent {
  id
  history(first: $first, after: $after, last: $last, before: $before, around: $around, when: $when, includePending: true, includeCancelled: $includeCancelled) {
    edges {
      dailySummaries {
        whenDayEnded
        date
        totalCommission
        ...AgentHistorySummary_summary
      }
      node {
        __typename
        id
        whenEntered
        isCancelled
        ... on AgentTransactionEntry {
          agentTransactionId
          composingEntries {
            __typename
            ... on AgentTransactionEntry {
              agentTransactionId
            }
            id
          }
        }
        ...AgentHistoryEntryDelegate_entry
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "around"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCancelled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "when"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentId"
  }
],
v9 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v10 = {
  "kind": "Variable",
  "name": "around",
  "variableName": "around"
},
v11 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v12 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v13 = {
  "kind": "Variable",
  "name": "includeCancelled",
  "variableName": "includeCancelled"
},
v14 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v15 = {
  "kind": "Variable",
  "name": "when",
  "variableName": "when"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "kind": "Literal",
    "name": "includePending",
    "value": true
  },
  (v14/*: any*/),
  (v15/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenEntered",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPending",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTransactionId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeposit",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ScamInvestigationFields",
      "kind": "LinkedField",
      "name": "scamInvestigationFields",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceModel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deviceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userInterface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentMobile",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SupportHistoryEntry",
  "abstractKey": "__isSupportHistoryEntry"
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transferId",
      "storageKey": null
    }
  ],
  "type": "TransferSentEntry",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentHistoryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "AgentHistory_agent"
              }
            ],
            "type": "Agent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentHistoryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "AgentHistoryConnection",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgentDailySummary",
                        "kind": "LinkedField",
                        "name": "dailySummaries",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "whenDayEnded",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalCommission",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dailyAward",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numSignups",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "absoluteTransactionVolume",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "effectiveTransactionVolume",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isHistoryEntry"
                          },
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "balance",
                            "storageKey": null
                          },
                          (v22/*: any*/),
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "composingEntries",
                                "plural": true,
                                "selections": [
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v20/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v24/*: any*/),
                                      (v25/*: any*/)
                                    ],
                                    "type": "AgentTransactionEntry",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currency",
                                "storageKey": null
                              },
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerMobile",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "maybeTerminatedCustomerMobile",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentUfid",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentUserName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subagentId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subagentName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subagentUfid",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isBusinessWalletAtx",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "merchantUfid",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "merchantId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "walletAgentUfid",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "walletAgentId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TicketShortInfo",
                                "kind": "LinkedField",
                                "name": "relatedTicket",
                                "plural": false,
                                "selections": [
                                  (v26/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "slackMessageUrl",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ScamReportTicket",
                                "kind": "LinkedField",
                                "name": "scamReports",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "whenOpened",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "whenResolved",
                                    "storageKey": null
                                  },
                                  (v26/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "transactionIds",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v27/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "type": "HistoryEntry",
                                "abstractKey": "__isHistoryEntry"
                              }
                            ],
                            "type": "AgentTransactionEntry",
                            "abstractKey": null
                          },
                          (v27/*: any*/),
                          (v28/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "filters": [
                  "around",
                  "when",
                  "includePending",
                  "includeCancelled"
                ],
                "handle": "connection",
                "key": "AgentHistory_history",
                "kind": "LinkedHandle",
                "name": "history"
              }
            ],
            "type": "Agent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a6d6780d68fa526ee9e8229cc25b0df2",
    "id": null,
    "metadata": {},
    "name": "AgentHistoryRefetchQuery",
    "operationKind": "query",
    "text": "query AgentHistoryRefetchQuery(\n  $agentId: ID!\n  $first: Int\n  $after: DateTime\n  $last: Int\n  $before: DateTime\n  $around: ID\n  $when: DateTime\n  $includeCancelled: Boolean\n) {\n  node(id: $agentId) {\n    __typename\n    ... on Agent {\n      ...AgentHistory_agent_26PW9Q\n    }\n    id\n  }\n}\n\nfragment AgentHistoryAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  currency\n  isDeposit\n  amount\n  customerName\n  customerMobile\n  maybeTerminatedCustomerMobile\n  agentId\n  agentName\n  agentUfid\n  agentUserName\n  subagentId\n  subagentName\n  subagentUfid\n  type\n  isBusinessWalletAtx\n  merchantUfid\n  merchantId\n  walletAgentUfid\n  walletAgentId\n  isCancelled\n  composingEntries {\n    __typename\n    amount\n    summary\n    isPending\n    isCancelled\n    whenEntered\n    ... on AgentTransactionEntry {\n      agentTransactionId\n      isDeposit\n    }\n    id\n  }\n  relatedTicket {\n    status\n    slackMessageUrl\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...AgentHistoryEntry_entry\n}\n\nfragment AgentHistoryEntryDelegate_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  __typename\n  ...AgentHistoryEntry_entry\n  ...AgentHistoryAtxEntry_tx\n}\n\nfragment AgentHistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment AgentHistorySummary_summary on AgentDailySummary {\n  date\n  whenDayEnded\n  dailyAward\n  numSignups\n  absoluteTransactionVolume\n  effectiveTransactionVolume\n  totalCommission\n}\n\nfragment AgentHistory_agent_26PW9Q on Agent {\n  id\n  history(first: $first, after: $after, last: $last, before: $before, around: $around, when: $when, includePending: true, includeCancelled: $includeCancelled) {\n    edges {\n      dailySummaries {\n        whenDayEnded\n        date\n        totalCommission\n        ...AgentHistorySummary_summary\n      }\n      node {\n        __typename\n        id\n        whenEntered\n        isCancelled\n        ... on AgentTransactionEntry {\n          agentTransactionId\n          composingEntries {\n            __typename\n            ... on AgentTransactionEntry {\n              agentTransactionId\n            }\n            id\n          }\n        }\n        ...AgentHistoryEntryDelegate_entry\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      hasNextPage\n      startCursor\n      endCursor\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '902ba4c2604286c2f3ed8e55513511c2';
export default node;
